<div class="row">
  <div class="col-6 input-group">






    <span class="input-group-btn">

      <button class="btn btn-primary rounded-0" (click)="refresh(1,nombre_fc,sucursal,null )">Buscar</button>
    </span>
  </div>
</div>






<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <div class="btn-toolbar mb-2 mb-md-0">
    <!-- *ngIf="canAccess(['edit_users'])"-->
    <!-- <a routerLink="/plants/create" class="btn btn-sm btn-outline-secondary">Agregar</a> -->
    <button (click)="mostrarBootstrapModal(null,'save')" class="btn btn-sm btn-outline-secondary"  >Agregar</button>
  </div>
</div>

<div class="table-responsive">
  <table class="table ">
    <thead>
      <tr>
        <th>id</th>
        <th>
          <select class="custom-select" id="sucursal" [(ngModel)]="sucursal"  (ngModelChange)="getCentroCostos(sucursal)">
            <option  value="">Seleccione...</option>
            <option *ngFor="let plant of plants" [value]="plant.id_planta">{{plant.nom_planta}}</option>
          </select>
        </th>
        <th>
          <select class="custom-select" id="orden_ceco" [(ngModel)]="orden_ceco"    (ngModelChange)="refresh(1)" >
          <option value="">Seleccione...</option>
          <option *ngFor="let ceco of centroCostos" [value]="ceco.orden_ceco">{{ceco.nombre_ceco}}</option>
        </select>
      </th>
      <th>
        <input type="text" id="cedula" class="form-control" [placeholder]="'Ingrese el Cedula'" [(ngModel)]="cedula"  (ngModelChange)="refresh(1)"   >
      </th>
        <th>
          <input type="text" id="nombre_fc" class="form-control" [placeholder]="'Ingrese el Nombre'" [(ngModel)]="nombre_fc"  (ngModelChange)="refresh(1)" >
        </th>
        <!-- <th>Action</th> -->

      </tr>
    </thead>

    <thead>
      <tr>
        <th>id</th>
        <th>Sucursal</th>
        <th>Centro de Costo</th>
        <th>Cedula</th>
        <th>Nombres</th>
        <th>Action</th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let per of personal">
        <td>{{per.id}}</td>
        <td>{{per.planta.nom_planta}}</td>
        <td>{{per.centroCosto.nombre_ceco}}</td>
        <th>{{per.cedula}}</th>
        <th>{{per.apellido1 + " " +  per.nombres }}</th>
        <td class="text-nowrap">
         
            <a href="javascript:void(0)" (click)="mostrarBootstrapModal(per.id,'edit')"
              class="btn  btn-outline-secondary mr-2"><i class="fa fa-pencil "></i></a>
            <a href="javascript:void(0)" (click)="delete(per.id)"
              class="btn  btn-outline-danger"><i class="fa fa-trash-o "></i></a>
         
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-paginator [lastPage]="lastPage" (pageChanged)="refresh($event)"></app-paginator>

